import { render, staticRenderFns } from "./153.vue?vue&type=template&id=229b9055&scoped=true&"
var script = {}
import style0 from "./153.vue?vue&type=style&index=0&id=229b9055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b9055",
  null
  
)

export default component.exports